















	import { Component } from 'vue-property-decorator';
	import MixinMain from '@/mixing/MixinMain.vue';
	import BarChart from '@/components/util/BarChart.vue';

	import { ChartData } from 'chart.js';
	import { internet } from '@/utils/Internet';
	import Util from '@/utils/Util';
	import { AxiosResponse } from 'axios';
	import ProgressChart from '@/components/main/ProgressChart.vue';
	@Component({
		name: 'RowChartBarLlm',
		components: {
			BarChart,
			ProgressChart,
		},
	})
	export default class RowChartBarLlm extends MixinMain {
	public titleChart = this.$t("MainMenu.titleQualityEvaluation");
	public labelChart = this.$t("MainMenu.labelQualityEvaluation");
	public subTitleChart = this.$t("MainMenu.titleBarChar");
	public chartEvAudiosTip: ChartData = {
		datasets: [],
	};
	public extraData: Array<number> = [];
	public isLoading = false;
	public selectedLabel = '';
	public chartLineTitle = '';
	public chartLineOpen = false;
	mounted() {
		console.log("ROW CHART BAR LLM");
		// console.log(localStorage.getItem('client'));
		this.getAllData();
	}

	public getAllData() {
		this.isLoading = true;
		console.log("ESTE ES EL FILTRO DE ROW CHART BAR LLM");
		console.log(this.getFilterUrl);
		const request_evAudio = internet
			.newRequest()
			.get(
				`getEvaluacionCualitativa?${this.getFilterUrl}`
			);
		Util.waitForPromises([
			request_evAudio,
		])
			.then((responses) => {
				console.log(responses[0] as AxiosResponse);
				let respuesta = responses[0].data;
				console.log("RESPUESTA: ", respuesta);
				this.extraData.push(respuesta.total);
				this.chartEvAudiosTip.datasets = [{data: [respuesta.porcentaje]}];
				this.$set(this.chartEvAudiosTip,'labels',[this.labelChart]);
				console.log(this.chartEvAudiosTip);
				console.log(this.extraData);
			})
			.catch(console.log)
			.finally(() => {
				this.isLoading = false;
			});
	}
}
